const TableEmptyState = ({ colSpan, message }) => {
  return (
    <tr className="common-table__empty-row">
      <td className="common-table__empty-cell" colSpan={colSpan}>
        {message}
      </td>
    </tr>
  );
};

export default TableEmptyState;
